import type { DataRetentionPeriod } from "@/src/services/company_service";

export const RETENTION_PERIOD_OPTIONS: { value: DataRetentionPeriod; label: string }[] = [
  { value: "day", label: "1 day" },
  { value: "week", label: "1 week" },
  { value: "month", label: "1 month" },
  { value: "indefinite", label: "Forever" },
];

export function RetentionPeriodPicker({
  value,
  onChange,
  disabled,
  size = "default",
}: {
  value: DataRetentionPeriod;
  onChange: (period: DataRetentionPeriod) => void;
  disabled?: boolean;
  size?: "default" | "small";
}) {
  return (
    <div className="flex flex-wrap gap-2" role="radiogroup" aria-label="Retention period">
      {RETENTION_PERIOD_OPTIONS.map((opt) => (
        <button
          key={opt.value}
          type="button"
          role="radio"
          aria-checked={value === opt.value}
          disabled={disabled}
          onClick={() => onChange(opt.value)}
          className={[
            "cursor-pointer rounded-[4px] border font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-60",
            size === "small" ? "px-2.5 py-1 text-small" : "px-3 py-1.5 text-small",
            value === opt.value
              ? "border-green-500-12 bg-green-500-12 text-green-700"
              : "border-grey-200 bg-white text-grey-900 hover:bg-grey-50",
          ].join(" ")}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
